import React, { useState, useEffect } from 'react'
import { Modal, Button } from 'react-bootstrap'
import PropTypes from 'prop-types'
import './styles.scss'
import { createSiteObject, toggleIronCladCheck } from 'src/utils/signUpUtils'
import { customerContainer, accountsContainer } from 'src/models'
import { APPConfig } from 'config/appConfig'
import { i18nTranslate } from 'src/utils'

const ConfirmationModal = ({ show, handleClose, content, inviteCallback }) => {
  const [ironCladCheckedString, setIronCladCheckedString] = useState('')

  // useEffect(() => {
  //   if (_ps) {
  //     _ps.on('checked', element => {
  //       const isIronCladString = toggleIronCladCheck(true, element)
  //       setIronCladCheckedString(isIronCladString)
  //     })
  //     _ps.on('unchecked', element => {
  //       const isIronCladString = toggleIronCladCheck(false, element)
  //       setIronCladCheckedString(isIronCladString)
  //     })
  //   }
  // }, [accountsContainer?.accountsTermCheck])

  // useEffect(() => {
  //   const groupKey = getGroupKeyBasedOnUserType()
  //   createSiteObject(groupKey, 'contractPage-3')
  //   setIronCladCheckedString('')
  // }, [show])

  const getGroupKeyBasedOnUserType = () => {
    const userType =
      customerContainer?.profileResponse?.accounts?.accountType || ''
    let groupKey = ''
    const genericBAGroupKey = APPConfig.getAppConfig().ironCladBACWG1Key || ''
    const jointAccountBAGroupKey =
      APPConfig.getAppConfig().jointAccountBAGroupKey || genericBAGroupKey || ''
    const jointAccountBABEGroupKey =
      APPConfig.getAppConfig().jointAccountBABEGroupKey ||
      jointAccountBAGroupKey ||
      genericBAGroupKey ||
      ''

    if (userType === 'Brand Affiliate') {
      groupKey = jointAccountBAGroupKey
    } else if (userType === 'Brand Affiliate - Business Entity') {
      groupKey = jointAccountBABEGroupKey
    }
    return groupKey
  }

  return (
    <Modal
      show={show}
      onHide={handleClose}
      className="participant-invite-modal-container">
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body className="modal-body-content">
        <p className="participant-popup-content">{content}</p>
        {/* {  <div id="clickwrap-container-3" className="click-wrap-container"></div> */}
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="primary"
          className="agree-invite-button"
          // disabled={ironCladCheckedString != 'clickwrap-container-3-true'}
          onClick={inviteCallback}>
          {i18nTranslate('participants.agreeAndInvite', 'Agree and Invite')}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

ConfirmationModal.propTypes = {
  show: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  content: PropTypes.string.isRequired,
  inviteCallback: PropTypes.func.isRequired,
}

export default ConfirmationModal
export { ConfirmationModal }
